import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'carrierType'
})
export class CarrierTypePipe implements PipeTransform {

  transform(value: number): string {
    switch(value) {
      case 1: 
        return 'Freight';
      case 2: 
        return 'Passenger';
      default:
        return 'Both';
    }
  }

}
